import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { collection, getDocs, limit, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import Home from './Home';
import './HomeWithStoryCTA.css';

function HomeWithStoryCTA() {
  const { currentUser } = useAuth();
  const [stories, setStories] = useState([]);

  useEffect(() => {
    let active = true;

    async function fetchPublishedStories() {
      try {
        const snapshot = await getDocs(
          query(collection(db, 'storySubmissions'), where('status', '==', 'published'), limit(3)),
        );

        if (!active) {
          return;
        }

        const publishedStories = snapshot.docs
          .map((storyDoc) => ({ id: storyDoc.id, ...storyDoc.data() }))
          .sort((a, b) => {
            const aTime = a.createdAt?.seconds || 0;
            const bTime = b.createdAt?.seconds || 0;
            return bTime - aTime;
          });

        setStories(publishedStories);
      } catch (error) {
        console.error('Failed to load published stories:', error);
      }
    }

    fetchPublishedStories();

    return () => {
      active = false;
    };
  }, []);

  return (
    <>
      <Home />

      {stories.length > 0 && (
        <section className="home-story-list" aria-labelledby="home-story-list-heading">
          <div className="home-story-list__inner">
            <div className="home-story-list__header">
              <p className="home-story-list__eyebrow">Real Stories</p>
              <h2 id="home-story-list-heading">みんなの体験談</h2>
              <p>掲載採用された投稿を、トップページで紹介します。</p>
            </div>

            <div className="home-story-list__grid">
              {stories.map((story) => (
                <article key={story.id} className="home-story-card">
                  <div className="home-story-card__image">
                    {story.imageUrl ? (
                      <img src={story.imageUrl} alt={story.title || story.mountainName || '体験談の写真'} />
                    ) : (
                      <div className="home-story-card__placeholder" />
                    )}
                  </div>
                  <div className="home-story-card__body">
                    <p className="home-story-card__meta">
                      {story.mountainName || '山名未設定'}
                      {story.prefecture ? ` / ${story.prefecture}` : ''}
                    </p>
                    <h3>{story.title}</h3>
                    <p className="home-story-card__text">{story.story}</p>
                    <p className="home-story-card__author">
                      {story.authorName || story.authorSnapshot?.nickname || story.authorSnapshot?.displayName || '投稿ユーザー'}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      )}

      <section className="home-story-cta" aria-labelledby="story-cta-heading">
        <div className="home-story-cta__inner">
          <div className="home-story-cta__copy">
            <p className="home-story-cta__eyebrow">Story Wanted</p>
            <h2 id="story-cta-heading">体験談を募集しています</h2>
            <p>
              サービス開始後にトップページへ掲載する体験談を受付中です。投稿画像および体験談はサイトに掲載される場合があります。
              サイト掲載に採用された場合、3,000 円分の Amazon ギフト券をお送りします。
            </p>
            <p className="home-story-cta__note">
              写真に映った方全員のご了承の上、投稿をお願いします。掲載候補の写真は、登山の雰囲気や一緒に過ごした様子が伝わる、
              明るく見やすいものを選んでください。
            </p>
          </div>

          <div className="home-story-cta__actions">
            <Link to="/stories/submit" className="home-story-cta__button">
              体験談を投稿する
            </Link>
            {!currentUser && (
              <p className="home-story-cta__hint">
                投稿にはログインが必要です。ボタンからそのまま進めます。
              </p>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default HomeWithStoryCTA;
